import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { HomeComponent } from './core/home/home.component';
import { AddEditComponent } from './admin/add-edit/add-edit.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AdminGuard } from './admin/shared/admin.guard';
import { RegisterLoginComponent } from './account/register-login/register-login.component';
import { OrdersComponent } from './account/orders/orders.component';
import { ProfileComponent } from './account/profile/profile.component';
import { AccountComponent } from './account/account.component';
import {MyListProductComponent} from './my-products/my-list-product/my-list-product.component';
import {MyDetailProductComponent} from './my-products/my-detail-product/my-detail-product.component';
import {MyCartComponent} from './my-cart/my-cart/my-cart.component';
import {MyCheckoutComponent} from './my-checkout/my-checkout.component';
import {ExcelUploadComponent} from './admin/excel-upload-component/excel-upload-component.component';
import {CompleteComponent} from './my-checkout/complete/complete.component';
import {CategoryGuard} from './my-products/shared/category.guards';
import {OrderAdminComponent} from './admin/order-admin/order-admin.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'listP/:category', component: MyListProductComponent, canActivate: [CategoryGuard] },
  { path: 'products/:categ/:name', component: MyDetailProductComponent },
  { path: 'cart', component: MyCartComponent },
  {
    path: 'admin',
    children: [
      { path: 'add', redirectTo: 'AddEditComponent', pathMatch: 'full' },
      { path: 'orders', component: OrderAdminComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'edit/:id', component: AddEditComponent },
      {
        path: 'excel',
        component: ExcelUploadComponent,
      }


    ]
  },


  { path: 'checkout', component: MyCheckoutComponent },
  { path: 'register-login', component: RegisterLoginComponent },
  {
    path: 'account',
    component: AccountComponent,
    children: [
      { path: '', redirectTo: 'profile', pathMatch: 'full' },
      { path: 'orders', component: OrdersComponent },
      { path: 'profile', component: ProfileComponent }
    ]
  },
  { path: 'order-complete', component: CompleteComponent },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
  providers: [
    AdminGuard,CategoryGuard
  ]
})
export class AppRoutingModule { }
